export default class SeoContentBlock{
  constructor(rootNode){
    this.root = rootNode;
    this.content = this.root.querySelector('.cms-content-block__content');
    this.allContent = this.content.innerHTML;
    this.isExpanded = false;
    this.config = [
      //make sure queries dont overlap
      {query:'(max-width: 480px)', maxChars: 79},
      {query:'(min-width: 481px) and (max-width: 767px)', maxChars: 220},
      {query:'(min-width: 768px)', maxChars: false},
    ];
    this.initMediaQueryMatches();
  }

  initMediaQueryMatches(){
    this.config.forEach((matchConfig)=>{
      const {query, maxChars} = matchConfig;
      const matcher = window.matchMedia(query);
      matcher.addListener(()=>{
        if(matcher.matches){
          this.clipContent(maxChars);
        }
      });
      //first time init
      if(matcher.matches){
        this.clipContent(maxChars);
      }
    });
  }

  clipContent(maxChars){
    this.currentMaxChars = maxChars;
    this.render();
  }

  onToggleExpand(e){
    e.preventDefault();
    this.isExpanded = !this.isExpanded;
    this.render();
  }

  render(){
    const maxChars = this.currentMaxChars;
    const shouldClip = !!maxChars;
    if(shouldClip){
      if(this.isExpanded){
        this.content.innerHTML = this.allContent;

        const viewLessLink = this.createCollapseLink('View less');
        this.content.appendChild(viewLessLink);
      }else{
        this.content.innerHTML = this.allContent.substring(0, maxChars).trim() + '...';

        const viewMoreLink = this.createCollapseLink('View more');
        let p = this.content.querySelector('p')
        if(p) {
          p.appendChild(viewMoreLink);
        } else {
          this.content.appendChild(viewMoreLink);
        }
      }
    }else{
      this.content.innerHTML = this.allContent;
    }
  }

  createCollapseLink(linkText){
    const viewMoreLink = document.createElement('a');
    viewMoreLink.innerHTML = linkText;
    viewMoreLink.setAttribute('href', '#');//so link will render correctly
    viewMoreLink.setAttribute('class', 'cms-content-block__content__expand-link');
    viewMoreLink.addEventListener('click', this.onToggleExpand.bind(this));
    return viewMoreLink;
  }
}


export function initSeoContentBlocks(){
  for(let container of document.querySelectorAll('.cms-content-block')){
    new SeoContentBlock(container);
  }
}
